import usePrivateAxios from '@/common/api/usePrivateAxios'
import { RefundValidationSchema } from '@/features/refund/schemas/create.schema'
import { useMutation } from '@tanstack/react-query'

interface UseCreateRefundProps {
  onSuccess?: (response: any) => void;
  onError?: (response: any) => void;
}

export const useCreateRefund = ({ onSuccess, onError }: UseCreateRefundProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['createRefund'],
    mutationFn: async (form: RefundValidationSchema) => {
      const refund = {
        ...form,
      }

      return privateAxios.post('/billing/refunds', {
        refund,
      })
    },
    onSuccess,
    onError,
  })
}
